import React, { useRef } from "react";
import ButtonBase from "../buttons/ButtonBase";
import DownloadButton from '../buttons/DownloadButton'
import {downloadFileByUrl} from "../../../../helpers/shared";


const InputFileUpload = ({ file, children, onFilesChanged, fileInputName }) => {
    const inputRef = useRef(null)

    const forseFileUpload = () => {
        inputRef.current?.click()
    }

    const resetInput = () => {
        onFilesChanged({
            target: {
                files: [null,]
            }
        })
    }

    return (
        <>
            {file && <label onClick={() => downloadFileByUrl(file, fileInputName)}>
                <DownloadButton name={fileInputName}/>
            </label>}

        <label htmlFor={fileInputName} onClick={forseFileUpload}>
            {file
                ? (
                    <div className="flex gap-2">
                        <ButtonBase onClick={resetInput} activestate="light" >Заменить</ButtonBase>
                    </div>
                )
                :
                    children
            }

            <input onChange={onFilesChanged} ref={inputRef} id={fileInputName} name={fileInputName} type="file" className="hidden" />
        </label>
        </>
    )
}

export default InputFileUpload